<template>
    <div>
        <div style="overflow: hidden;position: relative;">
            <div class="sidebar" ref="sidebar" id="left_sidebar" :class="showSideBar ? 'show' : ''">

                <div style="display: flex; align-items: center;padding: 19px 14px 13px;">
                    <!-- <div class="folder_add" v-if="tab == 'Lists' && add_folder_show" @click="addFolder" title="Add folder">
                        <img :src="require('@/assets/static/images/add_folder.svg')" alt="" />
                    </div> -->
                    <SearchTasks/>
                </div>

                <ul class="sidebar__tabs">
                    <li @click="changeTab('Lists')" :class="tab == 'Lists' ? 'active' : ''">
                        <p>{{ $t('tabs.lists') }}</p>
                        <span :style="unread_number_tasks > 0 ? 'opacity: 1;' : 'opacity: 0;'"></span>
                    </li>
                    <li @click="changeTab('Chats')" :class="tab == 'Chats' ? 'active' : ''">
                        <p>{{ $t('tabs.chats') }}</p>
                        <span :style="unread_number_chats > 0 ? 'opacity: 1;' : 'opacity: 0;'"></span>
                    </li>
                </ul>

                <ProjectsView :toggleCollapse="toggleCollapse" />

                <div v-if="getShowSmalActivityLog" class="sidebar__activity_log">
                    <ActivityLog :is_hidden="false" />
                </div>

                <div class="sidebar__info" :style="getShowSmalActivityLog ? 'background-color: #f2f2f2' : ''">
                    <ul class="create_lists" v-if="open_create_lists">
                        <li @click.prevent="addFolder" v-if="tab != 'Chats'">
                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.98 2.72H8.6411L6.21945 0.299203C6.12511 0.204082 6.01281 0.128649 5.88907 0.0772869C5.76533 0.0259244 5.63262 -0.000345135 5.49865 3.42365e-06H1.02C0.749479 3.42365e-06 0.490038 0.107467 0.298751 0.298754C0.107464 0.490041 0 0.749483 0 1.02V13.3127C0.000449442 13.5691 0.102505 13.8149 0.283812 13.9962C0.465119 14.1775 0.710894 14.2796 0.9673 14.28H16.0557C16.306 14.2798 16.5461 14.1802 16.7232 14.0032C16.9002 13.8261 16.9998 13.586 17 13.3357V3.74C17 3.46948 16.8925 3.21004 16.7012 3.01875C16.51 2.82747 16.2505 2.72 15.98 2.72ZM0.68 1.02C0.68 0.92983 0.715821 0.84335 0.779584 0.779587C0.843346 0.715825 0.929826 0.680003 1.02 0.680003H5.49865C5.58856 0.680158 5.67474 0.715915 5.73835 0.779453L7.6789 2.72H0.68V1.02ZM16.32 13.3357C16.3198 13.4057 16.2919 13.4728 16.2423 13.5223C16.1928 13.5719 16.1257 13.5998 16.0557 13.6H0.9673C0.891172 13.5998 0.818227 13.5694 0.764396 13.5156C0.710565 13.4618 0.680224 13.3888 0.68 13.3127V3.4H15.98C16.0702 3.4 16.1567 3.43582 16.2204 3.49959C16.2842 3.56335 16.32 3.64983 16.32 3.74V13.3357Z" fill="#0077FF"/>
                            </svg>
                            {{ $t('app.create.folder') }}
                        </li>
                        <li @click.prevent="showAddProjectWindow('Chats')">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.1 0H0.900016C0.661322 0 0.432403 0.103066 0.263621 0.286526C0.0948383 0.469985 1.72099e-05 0.71881 1.72099e-05 0.978261V14.0217C-0.00104873 14.2083 0.0474222 14.3912 0.139614 14.5485C0.231806 14.7058 0.363803 14.8309 0.519767 14.9087C0.638998 14.9685 0.7687 14.9997 0.900016 15C1.11134 14.9998 1.31574 14.918 1.47677 14.7693L1.48127 14.7644L3.89176 12.4679C3.94651 12.4178 4.01594 12.3906 4.08751 12.3913H14.1C14.3387 12.3913 14.5676 12.2882 14.7364 12.1048C14.9052 11.9213 15 11.6725 15 11.413V0.978261C15 0.71881 14.9052 0.469985 14.7364 0.286526C14.5676 0.103066 14.3387 0 14.1 0ZM14.4 11.413C14.4 11.4995 14.3684 11.5825 14.3121 11.6436C14.2559 11.7048 14.1796 11.7391 14.1 11.7391H4.08751C3.87347 11.7398 3.66653 11.8227 3.50326 11.9731L1.09127 14.272C1.04746 14.3114 0.994259 14.3365 0.937857 14.3443C0.881456 14.3521 0.824177 14.3423 0.772695 14.316C0.721214 14.2898 0.677649 14.2482 0.647077 14.1961C0.616505 14.144 0.600184 14.0835 0.600017 14.0217V0.978261C0.600017 0.891777 0.631624 0.808836 0.687884 0.747683C0.744145 0.68653 0.820451 0.652174 0.900016 0.652174H14.1C14.1796 0.652174 14.2559 0.68653 14.3121 0.747683C14.3684 0.808836 14.4 0.891777 14.4 0.978261V11.413Z" fill="#0077FF"/>
                            </svg>
                            {{ $t('app.create.chat') }}
                        </li>
                        <li @click.prevent="showAddProjectWindow('Lists')" class="list">
                            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 5.54348C15 5.62996 14.9656 5.7129 14.9045 5.77406C14.8433 5.83521 14.7604 5.86957 14.6739 5.86957H0.326087C0.239603 5.86957 0.156662 5.83521 0.0955087 5.77406C0.0343556 5.7129 0 5.62996 0 5.54348C0 5.457 0.0343556 5.37405 0.0955087 5.3129C0.156662 5.25175 0.239603 5.21739 0.326087 5.21739H14.6739C14.7604 5.21739 14.8433 5.25175 14.9045 5.3129C14.9656 5.37405 15 5.457 15 5.54348ZM0.326087 0.652174H14.6739C14.7604 0.652174 14.8433 0.617819 14.9045 0.556666C14.9656 0.495512 15 0.412571 15 0.326087C15 0.239603 14.9656 0.156662 14.9045 0.0955087C14.8433 0.0343556 14.7604 0 14.6739 0H0.326087C0.239603 0 0.156662 0.0343556 0.0955087 0.0955087C0.0343556 0.156662 0 0.239603 0 0.326087C0 0.412571 0.0343556 0.495512 0.0955087 0.556666C0.156662 0.617819 0.239603 0.652174 0.326087 0.652174ZM14.6739 10.4348H0.326087C0.239603 10.4348 0.156662 10.4691 0.0955087 10.5303C0.0343556 10.5914 0 10.6744 0 10.7609C0 10.8474 0.0343556 10.9303 0.0955087 10.9914C0.156662 11.0526 0.239603 11.087 0.326087 11.087H14.6739C14.7604 11.087 14.8433 11.0526 14.9045 10.9914C14.9656 10.9303 15 10.8474 15 10.7609C15 10.6744 14.9656 10.5914 14.9045 10.5303C14.8433 10.4691 14.7604 10.4348 14.6739 10.4348Z" fill="#0077FF"/>
                            </svg>
                            {{ $t('app.create.list') }}
                        </li>
                    </ul>
                    <div class="sidebar__support-btn" @click="openSupport">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.1 0H0.900016C0.661322 0 0.432403 0.103066 0.263621 0.286526C0.0948383 0.469985 1.72099e-05 0.71881 1.72099e-05 0.978261V14.0217C-0.00104873 14.2083 0.0474222 14.3912 0.139614 14.5485C0.231806 14.7058 0.363803 14.8309 0.519767 14.9087C0.638998 14.9685 0.7687 14.9997 0.900016 15C1.11134 14.9998 1.31574 14.918 1.47677 14.7693L1.48127 14.7644L3.89176 12.4679C3.94651 12.4178 4.01594 12.3906 4.08751 12.3913H14.1C14.3387 12.3913 14.5676 12.2882 14.7364 12.1048C14.9052 11.9213 15 11.6725 15 11.413V0.978261C15 0.71881 14.9052 0.469985 14.7364 0.286526C14.5676 0.103066 14.3387 0 14.1 0ZM14.4 11.413C14.4 11.4995 14.3684 11.5825 14.3121 11.6436C14.2559 11.7048 14.1796 11.7391 14.1 11.7391H4.08751C3.87347 11.7398 3.66653 11.8227 3.50326 11.9731L1.09127 14.272C1.04746 14.3114 0.994259 14.3365 0.937857 14.3443C0.881456 14.3521 0.824177 14.3423 0.772695 14.316C0.721214 14.2898 0.677649 14.2482 0.647077 14.1961C0.616505 14.144 0.600184 14.0835 0.600017 14.0217V0.978261C0.600017 0.891777 0.631624 0.808836 0.687884 0.747683C0.744145 0.68653 0.820451 0.652174 0.900016 0.652174H14.1C14.1796 0.652174 14.2559 0.68653 14.3121 0.747683C14.3684 0.808836 14.4 0.891777 14.4 0.978261V11.413Z" fill="#E58A8A"/>
                        </svg>
                        {{ $t('support_chat') }} {{ unread_number() > 0 ? `(${unread_number()})` : '' }}
                    </div>
                    <div class="sidebar_info_btn" :class="open_create_lists ? 'active' : ''" @click.stop="open_create_lists = !open_create_lists">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1C7.13261 1 7.25979 1.05268 7.35355 1.14645C7.44732 1.24021 7.5 1.36739 7.5 1.5V6.5H12.5C12.6326 6.5 12.7598 6.55268 12.8536 6.64645C12.9473 6.74021 13 6.86739 13 7C13 7.13261 12.9473 7.25979 12.8536 7.35355C12.7598 7.44732 12.6326 7.5 12.5 7.5H7.5V12.5C7.5 12.6326 7.44732 12.7598 7.35355 12.8536C7.25979 12.9473 7.13261 13 7 13C6.86739 13 6.74021 12.9473 6.64645 12.8536C6.55268 12.7598 6.5 12.6326 6.5 12.5V7.5H1.5C1.36739 7.5 1.24021 7.44732 1.14645 7.35355C1.05268 7.25979 1 7.13261 1 7C1 6.86739 1.05268 6.74021 1.14645 6.64645C1.24021 6.55268 1.36739 6.5 1.5 6.5H6.5V1.5C6.5 1.36739 6.55268 1.24021 6.64645 1.14645C6.74021 1.05268 6.86739 1 7 1V1Z" fill="#0077FF"/>
                        </svg>
                    </div>
                    <div class="sidebar_call_to_action">
                        <div class="sidebar_call_to_action__item" @click="openMenuSettings">
                            <div class="sidebar_call_to_action__item__container">
                                <div class="sidebar__history_change new_vertion" v-if="new_vertion"></div>
                                <span class="user_first_word">{{ getUserData.name[0] }}</span>
                            </div>
                        </div>
                        <div class="sidebar_call_to_action__item" @click="showSideBar = true">
                            <div class="sidebar_call_to_action__item__container">
                                <div class="sidebar__history_change" v-if="changeHistory"></div>
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.5 12.586V12.7931L15.6464 12.9396L17.3534 14.6466L17.3541 14.6472C17.4004 14.6934 17.4372 14.7482 17.4622 14.8087C17.4873 14.8691 17.5001 14.9339 17.5 14.9993V15V16C17.5 16.1326 17.4473 16.2598 17.3536 16.3536C17.2598 16.4473 17.1326 16.5 17 16.5H1C0.867392 16.5 0.740215 16.4473 0.646447 16.3536C0.55268 16.2598 0.500001 16.1326 0.500001 16L0.500002 15L0.500001 14.9993C0.499906 14.9339 0.512749 14.8691 0.53779 14.8087C0.562832 14.7482 0.599578 14.6934 0.645913 14.6472L0.646554 14.6466L2.35355 12.9396L2.5 12.7931V12.586V8C2.5 5.01527 4.52763 2.4982 7.27788 1.74002L7.51786 1.67386L7.60972 1.4425C7.82968 0.888473 8.36582 0.5 9 0.5C9.63419 0.5 10.1703 0.888473 10.3903 1.4425L10.4822 1.67395L10.7223 1.74006C13.4723 2.49724 15.5 5.01516 15.5 8V12.586ZM9.00063 19.5L8.99937 19.5C8.48398 19.5007 7.98119 19.3407 7.5609 19.0424C7.34743 18.8909 7.16063 18.7076 7.00627 18.5H10.9937C10.8394 18.7076 10.6526 18.8909 10.4391 19.0424C10.0188 19.3407 9.51602 19.5007 9.00063 19.5Z" fill="#00000000" stroke="#0077FF"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="project_filse_size" v-if="getUserData && getUserData.show_disk_usage">
                        <span class="project_filse_size__info">
                            {{ $w_parse_doc_size(getUserUsedFileSize) }} out of
                            {{ $w_parse_doc_size(getUserAllFileSize) }} used
                            <!-- <img :src="require('@/assets/static/images/quetion.svg')" alt="" @mouseover="showQuetionPopup = true" /> -->
                            <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @mouseover="showQuetionPopup = true" class="project_filse_size__info__question">
                                <path d="M7.875 0C3.52617 0 0 3.52617 0 7.875C0 12.2238 3.52617 15.75 7.875 15.75C12.2238 15.75 15.75 12.2238 15.75 7.875C15.75 3.52617 12.2238 0 7.875 0ZM7.875 12.4453C7.48652 12.4453 7.17188 12.1307 7.17188 11.7422C7.17188 11.3537 7.48652 11.0391 7.875 11.0391C8.26348 11.0391 8.57812 11.3537 8.57812 11.7422C8.57812 12.1307 8.26348 12.4453 7.875 12.4453ZM8.98066 8.58691C8.82147 8.64839 8.6845 8.75641 8.58761 8.89688C8.49072 9.03736 8.43841 9.20377 8.4375 9.37441V9.77344C8.4375 9.85078 8.37422 9.91406 8.29688 9.91406H7.45312C7.37578 9.91406 7.3125 9.85078 7.3125 9.77344V9.39551C7.3125 8.98945 7.43027 8.58867 7.6623 8.25469C7.88906 7.92773 8.20547 7.67812 8.57812 7.53574C9.17578 7.30547 9.5625 6.80449 9.5625 6.25781C9.5625 5.48262 8.80488 4.85156 7.875 4.85156C6.94512 4.85156 6.1875 5.48262 6.1875 6.25781V6.39141C6.1875 6.46875 6.12422 6.53203 6.04688 6.53203H5.20312C5.12578 6.53203 5.0625 6.46875 5.0625 6.39141V6.25781C5.0625 5.56699 5.36484 4.92188 5.91328 4.44199C6.44062 3.97969 7.13672 3.72656 7.875 3.72656C8.61328 3.72656 9.30937 3.98145 9.83672 4.44199C10.3852 4.92188 10.6875 5.56699 10.6875 6.25781C10.6875 7.27383 10.0178 8.18789 8.98066 8.58691Z" fill="#0077FF"/>
                            </svg> -->
                        </span>
                        <el-progress :percentage="usedSizeBar"></el-progress>
                    </div>
                </div>
            </div>
            <div class="sidebar__activity_log_hidden vertical_scrollbar" :class="showSideBar ? 'show' : ''">
                <ActivityLog :is_hidden="true" @hide="showSideBar = false" />
            </div>
        </div>
        <SettingsMenu :show="show"></SettingsMenu>
        <div class="quetion_popup" v-if="showQuetionPopup">
            <div class="quetion_popup__text">
                Tip: You can either delete your old projects or tasks to empty space or <span @click="openSettingPlan">upgrade your plan</span>
            </div>
            <div class="quetion_popup__icon" @click="showQuetionPopup = false">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.47266 0.296875C3.57266 0.296875 0.472656 3.50472 0.472656 7.54039C0.472656 11.5761 3.57266 14.7839 7.47266 14.7839C11.3727 14.7839 14.4727 11.5761 14.4727 7.54039C14.4727 3.50472 11.3727 0.296875 7.47266 0.296875ZM7.47266 13.7491C4.17266 13.7491 1.47266 10.9552 1.47266 7.54039C1.47266 4.12559 4.17266 1.33166 7.47266 1.33166C10.7727 1.33166 13.4727 4.12559 13.4727 7.54039C13.4727 10.9552 10.7727 13.7491 7.47266 13.7491Z" fill="#929292"/>
                    <path d="M9.81819 10.6775L7.50391 8.28268L5.18962 10.6775L4.50391 9.96791L6.81819 7.57311L4.50391 5.17832L5.18962 4.46875L7.50391 6.86354L9.81819 4.46875L10.5039 5.17832L8.18962 7.57311L10.5039 9.96791L9.81819 10.6775Z" fill="#929292"/>
                </svg>
            </div>
        </div>
        <ChatContextMenu />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ProjectsView from "@/components/projects/ProjectsView";
import SearchTasks from "@/components/tasks/SearchTasks";
import ActivityLog from "@/components/history/ActivityLog";
import SettingsMenu from './SettingsMenu.vue'
import { EventEmitter } from '../../main'
import ChatContextMenu from "../chats/ChatContextMenu.vue";

export default {
  name: "LeftSidebar",
  data() {
    return {
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      toggleCollapse: false,
      usedSizeBar: 0,
      showSideBar: false,
      show: false,
      tab: 'Lists',
      changeHistory: false,
      showQuetionPopup: false,
      unread_number_tasks: 0,
      unread_number_chats: 0,
      new_vertion: false,
      add_folder_show: true,
      open_create_lists: false
    };
  },
  mounted() {

    this.$root.$on('onboard:openMenuCreateList', () => {
        this.open_create_lists = true
    })

    this.$root.$on('onboard:openPopupCreateList', () => {
        this.showAddProjectWindow('Lists')
    })

    EventEmitter.$on('SearchInputFocus', (data) => {
        this.add_folder_show = data
    })

    EventEmitter.$on('new_vertion', () => {
        this.new_vertion = true
    })
    
    if (window.location.href.split('/').indexOf('project') > -1) {
        this.tab = 'Lists'
    }

    if (window.location.href.split('/').indexOf('chats') > -1) {
        this.tab = 'Chats'
    }

    if (window.location.href.split('/').indexOf('shortcuts') > -1) {
        this.tab = 'Lists'
    }
    
    this.showProgressSize();

    document.querySelector('body').onclick = () => {
        if (this.show) {
            this.show = false
        }
        if (this.open_create_lists) {
            this.open_create_lists = false
        }
    }

    EventEmitter.$on('closeMenuSettings', (e) => {
        this.show = false
    })
    EventEmitter.$on('changeSidebarTabs', (e) => {
        this.tab = e
    })

    let unread_number = 0
    Object.values(this.get_unreaded_messages_in_project).forEach(count => {
        unread_number += count
    })
    this.unread_number_tasks = unread_number
    window.unread_msg_tasks = unread_number

    let unread_number2 = 0
    this.getChats.forEach((chat, i) => {
        chat.users.forEach((user, user_i) => {
            if (user.user_id == this.getUserData._id) {
                unread_number2 = parseInt(user.unread_number) + parseInt(unread_number2)
            }
        })
    })
    this.unread_number_chats = unread_number2
    window.unread_msg_chats = unread_number2

    this.changeHistory = this.getUserData.activity_log_new
    this.handleUnreadNumberInTab(this.unread_number_tasks, this.unread_number_chats)

  },
  methods: {
    ...mapActions([
        "add_folder_render_lists",
    ]),
    ...mapMutations([
        "activity_log_new",
        "setChangeUserData",
        "setMessage"
    ]),
    openSettingPlan() {
        this.showQuetionPopup = false
        EventEmitter.$emit('openSettingPlan', true)
    },
    openMenuSettings(e) {
        e.stopPropagation()
        this.show = !this.show
    },
    changeTab(e) {
        EventEmitter.$emit('changeTab', e)
        this.tab = e
    },
    toggle_collapse(value) {
      this.toggleCollapse = value;
      this.$emit("toggle_collapse");
    },
    showAddProjectWindow(tab) {
        this.open_create_lists = false
        this.$root.$emit("openEditLists", tab);
    },
    showProgressSize() {
        // setTimeout(() => {
            // console.log(this.getUserAllFileSize, this.getUserUsedFileSize)
            let size = this.getUserUsedFileSize / (this.getUserAllFileSize / 100);
            this.usedSizeBar = size < 1 && size > 0
                ? 1
                : size < 1
                ? 0
                : Math.ceil(
                    this.getUserUsedFileSize / (this.getUserAllFileSize / 100)
                );
        // }, 2000);
    },
    getTitle(title = document.title) {
        title = title.split(' ')
        let last = title[title.length-1]
        last = last.replaceAll('(', '')
        last = last.replaceAll(')', '')

        if (!isNaN(last)) {
            title.pop()
        }
        return title.join(' ')
    },
    handleUnreadNumberInTab(firstVal, secondVal) {
        let count = secondVal + firstVal
        const title = this.getTitle()
        count = count > 0 ? `(${count})` : ''
        document.title = title + ' ' + count
        window.unread_msg_tasks = firstVal
        window.unread_msg_chats = secondVal
    },
    addFolder() {
        let w_bool = false
        this.open_create_lists = false

        this.$w_plan(this, this.getPlan, 'folder', () => {
            this.setMessage({
                key_message: "warning",
                message: this.$planMessages.folder.en,
                plan: true
            })
            w_bool = true
        })

        if (w_bool) {
            return
        }

        this.setChangeUserData({
            type: 'add_folder',
            field: {
                _id: this.$w_decrypt(this.getUserData._id),
                name: '',
                lists: [],
                order: this.getLists['folder'].length > 0 ? this.getLists['folder'].length : 0
            }
        })
        setTimeout(() => {
            this.add_folder_render_lists()
        }, 100);
        setTimeout(() => {
            document.querySelector('.folder__flex input').focus()
        }, 500);
    },
    unread_number() {
        const chat = this.getChats.find(chat => chat.support == true)
        if (!chat) {
            return ''
        }
        let unread_number = ''
        chat.users.forEach((user) => {
            if (user.user_id == this.getUserData._id) {
                unread_number = user.unread_number;
            }
        });
        return unread_number;
    },
    openSupport() {
        const chat = this.getChats.find(chat => chat.support == true)
        if (chat) {
            this.$router.push(`/chats/${chat._id}`).catch(()=>{})
        } else {
            let chat_id = this.$w_decrypt(this.getUserData._id)
            this.$socket.emit('IN_SupportAdd', {chat_id, create: false})
        }
    }
  },
  computed: {
    ...mapGetters([
        "getUserData",
        "getUserUsedFileSize",
        "getUserAllFileSize",
        "getShowSmalActivityLog",
        "getChats",
        "getTasks",
        "getProjects",
        "getChangeHistory",
        "get_unreaded_messages_in_project",
        "get_flag_for_unreaded",
        "getRender",
        "getPlan",
        "getLists"
    ])
  },
  watch: {
    get_flag_for_unreaded() {
        let unread_number = 0
        Object.values(this.get_unreaded_messages_in_project).forEach(count => {
            unread_number += count
        })
        this.unread_number_tasks = unread_number
        this.handleUnreadNumberInTab(this.unread_number_tasks, this.unread_number_chats)
    },
    get_unreaded_messages_in_project(newVal) {
        this.unread_number_tasks = 0
        let unread_number = 0
        Object.values(newVal).forEach(count => {
            unread_number += count
        })
        this.unread_number_tasks = unread_number
    },
    getChangeHistory() {
        this.changeHistory = this.getUserData.activity_log_new
    },
    getUserUsedFileSize() {
        this.showProgressSize()
    },
    getShowSmalActivityLog(e) {
        console.log(e)
    },
    showSideBar(e) {
        if (e) {
            this.changeHistory = false
            this.activity_log_new(false)
            this.$socket.emit('IN_HistoryRead', false)
        }
    },
    unread_number_tasks(newVal) {
        this.handleUnreadNumberInTab(newVal, this.unread_number_chats)
    },
    unread_number_chats(newVal) {
        this.handleUnreadNumberInTab(newVal, this.unread_number_tasks)
    },
    $route() {
        this.handleUnreadNumberInTab(this.unread_number_tasks, this.unread_number_chats)
    },
    getRender() {
        let unread_number2 = 0
        this.getChats.forEach((chat, i) => {
            chat.users.forEach((user, user_i) => {
                if (user.user_id == this.getUserData._id) {
                    unread_number2 = parseInt(user.unread_number) + parseInt(unread_number2)
                }
            })
        })
        this.unread_number_chats = unread_number2
        this.handleUnreadNumberInTab(this.unread_number_tasks, this.unread_number_chats)
        // window.unread_msg_chats = unread_number2
    }
  },
  components: {
    ProjectsView,
    SearchTasks,
    ActivityLog,
    SettingsMenu,
    ChatContextMenu
  },
};
</script>
